// eslint-disable-next-line @typescript-eslint/no-var-requires
const pino = require('pino');

const logger = pino({
  level: process.env.PINO_LOG_LEVEL || 'info',
  formatters: {
    level: (label) => ({ level: label.toUpperCase() }),
  },
  timestamp: pino.stdTimeFunctions.isoTime,
});

module.exports = logger;
